import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
// Self-hosted fonts: no requests to Google Fonts or Fontshare, so first paint is faster,
// visitor IPs are not shared with font hosts, and the security policy can stay 'self'.
// Brand typography (Lora, Poppins) is declared in index.css from /fonts, self-hosted
// (CSP font-src 'self') and preloaded in public/index.html.
import "@/index.css";
import App from "@/App";
import { ScrollToTop } from "@/components/ScrollToTop";
import { StructuredData } from "@/components/StructuredData";
import EnterprisePage from "@/pages/EnterprisePage";
import HealthcarePage from "@/pages/HealthcarePage";
import ServicesPage from "@/pages/ServicesPage";
import ServiceDetailPage from "@/pages/ServiceDetailPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import NotFoundPage from "@/pages/NotFoundPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import AccessibilityPage from "@/pages/AccessibilityPage";
import PerspectivePage from "@/pages/PerspectivePage";
import PerspectivePostPage from "@/pages/PerspectivePostPage";

const container = document.getElementById("root");
// Pages ship as prerendered HTML (react-snap). Remember that, so above-the-fold
// entrance animations do not hide content that is already on screen.
window.__EL_PRERENDERED = container.hasChildNodes();
const app = (
  <React.StrictMode>
    <BrowserRouter>
      <ScrollToTop />
      <StructuredData />
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/enterprise" element={<EnterprisePage />} />
        <Route path="/healthcare-secure" element={<HealthcarePage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/services/:slug" element={<ServiceDetailPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/accessibility" element={<AccessibilityPage />} />
        <Route path="/perspective" element={<PerspectivePage />} />
        <Route path="/perspective/:slug" element={<PerspectivePostPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// Hydrate prerendered pages so the browser keeps the HTML it already painted
// (fast LCP); fall back to a normal render when there is no prerendered markup.
if (window.__EL_PRERENDERED) {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}
